module.exports = __webpack_public_path__ + "static/media/cdplayer_114.eb5da7ae.ico";